export default __webpack_public_path__ + "static/media/putovanja.604068aa.png";